
































































































































import { Component } from "vue-property-decorator";
import { WorkerWizardModule } from "@/store/modules/workerWizard";
import GiganautVueForm from "@/components/Shared/GiganautVueForm";
import WorkType from '@/models/Shared/WorkType';
import WorkerWizardCsvUpload from '@/components/Workers/WorkerWizardCsvUpload.vue';
import WorkerWizardCvUpload from '@/components/Workers/WorkerWizardCvUpload.vue';

@Component({
  name: "WorkerWizardWorkType",
  components: { WorkerWizardCsvUpload, WorkerWizardCvUpload },
})
export default class WorkerWizardWorkType extends GiganautVueForm {

  showValidationError = false;

  async validateForm() {
    // Check if at least one work type is selected
    if (!this.hasWorkTypeSelected) {
      this.showValidationError = true;
      return true; // Return true to indicate validation error
    }
    this.showValidationError = false;
    return false; // Return false to indicate validation passed
  }

  get worker() {
    return WorkerWizardModule.newWorker.worker;
  }

  get isPermSelected() {
    return this.worker.workTypes && this.worker.workTypes.includes(WorkType.Perm);
  }

  get isTempSelected() {
    return this.worker.workTypes && this.worker.workTypes.includes(WorkType.Temp);
  }

  get hasWorkTypeSelected() {
    return this.worker.workTypes && this.worker.workTypes.length > 0;
  }

  get cvImportSummary() {
    return WorkerWizardModule.cvImportSummary;
  }

  toggleWorkType(workType: string) {
    if (!this.worker.workTypes) {
      this.worker.workTypes = [];
    }

    const index = this.worker.workTypes.indexOf(workType);
    if (index > -1) {
      // Remove if already selected
      this.worker.workTypes.splice(index, 1);
    } else {
      // Add if not selected
      this.worker.workTypes.push(workType);
    }

    // Clear validation error when user selects a work type
    if (this.hasWorkTypeSelected) {
      this.showValidationError = false;
    }
  }
}
